import { render, staticRenderFns } from "./UnificadorContainer.vue?vue&type=template&id=6db578fc&scoped=true"
import script from "./UnificadorContainer.vue?vue&type=script&lang=js"
export * from "./UnificadorContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db578fc",
  null
  
)

export default component.exports